module.exports = __webpack_public_path__ + "static/img/friend3.37fd5da.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/friend3.jpeg
// module id = aDBP
// module chunks = 1